/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("LogProviderBase", function (context, cls) {
  /**
   * @class LogProviderBase
   * @memberOf classes
   */
  class LogProviderBase /** @lends classes.LogProviderBase.prototype */ {
    constructor() {
      /** @type {boolean} */
      this._enabled = false;
    }

    /**
     * Get the logger with all necessary methods
     * @return {Object|null}
     */
    getLogger() {
      throw new Error("LogProvider is abstract. Implement it to log.");
    }

    /**
     * Activate this logProvider
     * @param {Boolean} enable - true to enable, false otherwise
     */
    enable(enable) {
      this._enabled = enable;
    }

    /**
     * Check if this logProvider is enabled
     * @param {string} [logLevel] current log level
     * @return {boolean} true if enabled, false otherwise
     */
    isEnabled(logLevel = "") {
      return this._enabled || logLevel === "error" || logLevel === "warn" || logLevel === "info";
    }
  }
  cls.LogProviderBase = LogProviderBase;
});
